import React from "react";
import { Routes, Route } from "react-router-dom";
import ProfilePage from "./ProfilePage";
import CreateVisualPage from "./CreateVisualPage";
import SettingsPage from "./SettingsPage";
import DashboardBody from "./DashboardBody";
import "./DashboardPage.css";
const profileURLAliases = ["myvisuals", "myvisualizations", "mylibrary", "myportfolio", "mypresentations"];
const DashboardContainer = (props) => {
  // Cleanup effect removed - issue was global CSS in OrganSegmentationPageV2.css
  
  return (
    <div className="dashboard-container">
      <div className="dashboard-content-wrapper">
        <Routes>
          {profileURLAliases.map((alias) => (
            <Route key={alias} path={alias} element={<ProfilePage isOrg={false} />} />
          ))}
          <Route
            path="upload/*"
            element={
              <CreateVisualPage
                isOrg={false}
              />
            }
          />
          <Route path="settings" element={<SettingsPage />} />
          <Route path='*' element={<DashboardBody />} />
        </Routes>
      </div>
    </div>
  );
};

export default DashboardContainer; 